/**
 * Frontend Utilities - Funciones compartidas sin dependencia de Blade
 * Incluye: switchLanguage, modal helpers, avatar preview
 */

// =============================================
// LANGUAGE SWITCHER
// =============================================

window.switchLanguage = function (newLocale) {
    const currentPath = window.location.pathname;
    let newPath = currentPath.replace(/\/(es|en)\//, '/' + newLocale + '/');

    // If path doesn't contain locale, add it
    if (!currentPath.match(/\/(es|en)\//)) {
        newPath = '/' + newLocale + currentPath;
    }

    window.location.href = newPath;
};

// =============================================
// MODAL UTILITIES (migration modal, update password modal)
// =============================================

/**
 * Inicializar modal genérico con cierre por click fuera y ESC
 * @param {string} modalId - ID del modal
 * @param {string} closeFnName - Nombre de la función global de cierre
 */
function initSimpleModal(modalId, closeFnName) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    // Función de cierre global
    window[closeFnName] = function () {
        modal.style.display = 'none';
    };

    // Cerrar al hacer clic fuera del modal
    modal.addEventListener('click', function (event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    });

    // Cerrar con ESC
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.style.display !== 'none') {
            modal.style.display = 'none';
        }
    });
}

// Abrir modal (para password-migration)
window.showUpdateForm = function () {
    const modal = document.getElementById('updatePasswordModal');
    if (modal) modal.style.display = 'block';
};

// =============================================
// AVATAR PREVIEW (profile page)
// =============================================

function initAvatarPreview() {
    const avatarInput = document.getElementById('avatarInput');
    const avatarPreview = document.getElementById('avatarPreview');

    if (!avatarInput || !avatarPreview) return;

    avatarInput.addEventListener('change', function (e) {
        const file = e.target.files[0];
        if (!file) return;

        // Mensajes (usamos data attributes si están disponibles, o defaults en español)
        const errorSizeMsg = avatarInput.dataset.errorSize || 'La imagen no puede ser mayor a 10MB';
        const errorTypeMsg = avatarInput.dataset.errorType || 'Por favor selecciona un archivo de imagen válido (JPEG, PNG, GIF, WebP)';

        // Validar tamaño (10MB)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            alert(errorSizeMsg);
            avatarInput.value = '';
            return;
        }

        // Validar tipo de archivo
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            alert(errorTypeMsg);
            avatarInput.value = '';
            return;
        }

        // Mostrar preview
        const reader = new FileReader();
        reader.onload = function (e) {
            avatarPreview.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
}

// =============================================
// INITIALIZE ALL
// =============================================

document.addEventListener('DOMContentLoaded', function () {
    // Modal de migración (home page)
    initSimpleModal('migrationModal', 'closeMigrationModal');

    // Modal de actualizar contraseña (password-migration page)
    initSimpleModal('updatePasswordModal', 'closeModal');

    // Avatar preview (profile page)
    initAvatarPreview();
});
